import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M19.734 11.484a.516.516 0 0 0-.516.516c0 3.98-3.239 7.219-7.219 7.219S4.78 15.98 4.78 12s3.239-7.219 7.219-7.219a7.181 7.181 0 0 1 5.924 3.113h-1.302a.516.516 0 1 0 0 1.032h2.514a.516.516 0 0 0 .516-.516V5.896a.516.516 0 1 0-1.032 0v1.203a8.203 8.203 0 0 0-6.62-3.35c-4.549 0-8.25 3.701-8.25 8.25s3.701 8.25 8.25 8.25 8.25-3.701 8.25-8.25a.516.516 0 0 0-.516-.516z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M11.484 7.359v4.427l-2.301 2.301a.516.516 0 0 0 .73.729l2.451-2.452a.514.514 0 0 0 .152-.364V7.359a.516.516 0 1 0-1.032 0z"
  })]
}), 'Delay');